import { connect } from 'react-redux';
import VerifyPhoneHeader from 'common/components/header_verify_phone';

const mapStateToProps = (state) => {
  return {
    mobileValidated: state.user.mobileValidated
  };
}

export default connect(mapStateToProps)(VerifyPhoneHeader);



// WEBPACK FOOTER //
// ./common/containers/header_verify_phone.js